
declare global {
    interface Window {
        getTimeZoneAzureFunction: string;
        createServiceProviderFunction: string;
    }
}

namespace gorelo.web {
    export interface IApiConstants {
        actions: {
            gettimezoneazurefunction: string;
            createserviceproviderazurefunction: string;
            validateserviceproviderazurefunction: string;
            sendotpazurefunction: string;
            verifyotpazurefunction: string;
        }

        code: {
            gettimezoneazurefunctioncode: string;
            createserviceproviderazurefunctioncode: string;
            validateserviceproviderazurefunctioncode: string;
            sendotpazurefunctioncode: string;
            verifyotpazurefunctioncode: string;
        }
    }
}

import { Enums } from "@/common/helper/enum";

const signupAPIUrlTemplate: string = import.meta.env.VITE_signupAPIUrl ?? "";
const regionUrlPlaceholder = "{region}";

/** Mirrors the web-app's `applyRegionToUrlTemplate` — replaces `{region}` with the slug. */
function applyRegionToUrlTemplate(template: string, slug: string): string {
    if (!template.includes(regionUrlPlaceholder)) return template;
    return template.split(regionUrlPlaceholder).join(slug);
}

export function getSignupBaseUrl(region: number | null | undefined): string {
    const slug = region === Enums.Region.Australia
        ? Enums.RegionSlug.Australia
        : Enums.RegionSlug.UsWest;
    return applyRegionToUrlTemplate(signupAPIUrlTemplate, slug);
}

/**
 * Resolves region-specific signup URLs.
 *
 * Region is passed per-call (not read from a global/window like the web-app) because
 * here the region is user-selectable via a dropdown and can change mid-session. Resolving
 * the URL at call time guarantees each request targets the region currently selected,
 * avoiding stale state. Do NOT replace this with a global mutable region or lazy getter.
 */
export function getServiceProviderUrls(region: number | null | undefined) {
    const base = getSignupBaseUrl(region);
    return {
        createServiceProvider: `${base}/api/${apiConstants.actions.createserviceproviderazurefunction}?code=${apiConstants.code.createserviceproviderazurefunctioncode}`,
        validatePhoneNumberAndSignup: `${base}/api/${apiConstants.actions.validatephonenumberandsignupazurefunction}?code=${apiConstants.code.validatephonenumberandsignupazurefunctioncode}`,
        getTimeZoneAzureFunction: `${base}/api/${apiConstants.actions.gettimezoneazurefunction}?code=${apiConstants.code.gettimezoneazurefunctioncode}`,
        validateserviceprovider: `${base}/api/${apiConstants.actions.validateserviceproviderazurefunction}?code=${apiConstants.code.validateserviceproviderazurefunctioncode}`,
        sendotp: `${base}/api/${apiConstants.actions.sendotpazurefunction}?code=${apiConstants.code.sendotpazurefunctioncode}`,
        verifyotp: `${base}/api/${apiConstants.actions.verifyotpazurefunction}?code=${apiConstants.code.verifyotpazurefunctioncode}`,
    };
}

// timeout constant
export const dropdownSearchTimeout = 300;



export const apiConstants: gorelo.web.IApiConstants = {

    actions: {
        gettimezoneazurefunction: "GetTimezones",
        createserviceproviderazurefunction: "CreateServiceProviderFunction",
        validateserviceproviderazurefunction: "ValidateServiceProviderFunction",
        sendotpazurefunction: "SendOTPCodeFunction",
        verifyotpazurefunction: "VerifyOTPCodeFunction",
    },
    code: {
        gettimezoneazurefunctioncode: import.meta.env.VITE_getTimeZoneAzureFunctionCode,
        createserviceproviderazurefunctioncode: import.meta.env.VITE_CreateServiceProviderFunctionCode,
        validateserviceproviderazurefunctioncode: import.meta.env.VITE_ValidateServiceProviderFunctionCode,
        sendotpazurefunctioncode: import.meta.env.VITE_SendOTPCodeFunctionCode,
        verifyotpazurefunctioncode: import.meta.env.VITE_VerifyOTPCodeFunctionCode,
    }
};

export const constants = {

    localStorage: {
        keys: {
            rules: "rules",
            routes: "routes",
        }
    },
    validations: {
        phoneNumberMinLength: 6,
        phoneNumberMaxLength: 15,
        emailMaxLength: 200
    },
    AppVersion: "api-version=1.0",
};

export const environment = import.meta.env.VITE_environment || "";
